import { FsaFirm } from './fsa-firm.model';

export class FsaPermission {
  public FsaPermissionID: number;
  public FsaRef: number;
  public Activity?: number;
  public Investment: string;
  public Customer: string;
  public Status: string;
  public SDate: Date;
  public Change: Date;
  public FsaFirm: FsaFirm;
}
